var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'profilePayments-component': true,
  'profilePayments-component__mob': _vm.$vuetify.breakpoint.xsOnly,
  'custom-scrollbar': true,
  }},[_c('div',[_c('Title',{attrs:{"text":_vm.pageTitle,"size":26,"mobSize":22,"weight":900,"position":'start',"mobPosition":'start'}}),_c('NavigationPanel',{attrs:{"tabs":_vm.childrenLinks}}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }